export default __webpack_public_path__ + "static/media/5.4284cca1.svg";